"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseBackgroundTaskOut = void 0;
class ListResponseBackgroundTaskOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseBackgroundTaskOut.attributeTypeMap;
    }
}
exports.ListResponseBackgroundTaskOut = ListResponseBackgroundTaskOut;
ListResponseBackgroundTaskOut.discriminator = undefined;
ListResponseBackgroundTaskOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<BackgroundTaskOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseBackgroundTaskOut.js.map